import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');
var serviceName = "index";
var rakamService = {
    rakamTanimlama(rakamAdi, icon, sayi) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                rakamAdi: rakamAdi,
                icon: icon,
                sayi: sayi,
                serviceName: "rakam",
                methodName: "rakamTanimlama"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    rakamListesi(baslangic, limit, durum) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                baslangic: baslangic,
                limit: limit,
                durum: durum,
                serviceName: "rakam",
                methodName: "rakamListesi"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    rakamDetay(rakamId) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                rakamId: rakamId,
                serviceName: "rakam",
                methodName: "rakamDetay"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    rakamDurumGuncelle(rakamId,durum) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                rakamId: rakamId,
                durum:durum,
                serviceName: "rakam",
                methodName: "rakamDurumGuncelle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    rakamGuncelle(rakamId, rakamAdi, rakam, icon) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                rakamId: rakamId,
                rakamAdi: rakamAdi,
                rakam: rakam,
                icon: icon,
                serviceName: "rakam",
                methodName: "rakamGuncelle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    }


}

export default rakamService

